<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="parentx">
    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe="onMenuSwipe"
    >
      <div
        @mouseenter.stop.prevent="mouseEnter({ tag: 'main', evt: $event })"
        @mouseleave.stop.prevent="mouseLeave"
        @mousedown.stop=""
        @touchstart.stop=""
      >
        <component
          v-if="menus"
          :is="scrollbarTag"
          ref="verticalNavMenuPs"
          class="scroll-area-v-nav-menu scroll-area--aisea-menu pt-2"
          :settings="settings"
          :key="$vs.rtl"
        >
          <!-- Header -->
          <div class="header-sidebar ">
            <div
              class="flex items-center justify-between"
              slot="header"
            >
              <!-- Logo -->
              <div class="vx-logo flex items-center">
                <logo class="w-100 fill-current text-primary" :isOpen="isMouseEnter || !reduce" />
              </div>
              <!-- /Logo -->

              <!-- Menu Buttons -->
              <div class="close-reduce-btn-wrapper">
                <!-- Close Button -->
                <template v-if="showCloseButton">
                  <img
                    src="@/assets/images/icons/lolcal/close.svg"
                    class="m-0 cursor-pointer"
                    @click.stop.prevent="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)"
                  />
                </template>

                <!-- Toggle Buttons -->
                <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">
                  <img
                    src="@/assets/images/icons/lolcal/close.svg"
                    class="m-0 cursor-pointer"
                    :class="{ 'reduce-active': reduce }"
                    @click.stop.prevent="toggleReduce(!reduce)"
                  />
                </template>
              </div>

            </div>
            <div
              class="aisea-version-text aisea-text-10-400-white"
              v-show="isMouseEnter || !reduce"
              v-if="version"
              >Ver. {{ version }}</div
            >
            <!-- /Menu Toggle Buttons -->
          </div>

        <!-- /Header -->

        <!-- Header Shadow -->
        <!--        <div class="shadow-bottom" v-show="showShadowBottom" />-->

        <!-- Menu Items -->
          <template v-for="(item, index) in menus">
            <!-- Group Header -->
            <span
              v-if="item.header && !verticalNavMenuItemsMin"
              class="navigation-header truncate aisea-text-12-700-white"
              :class="{'text-capitalize': item.header === 'EcoShip'}"
              :key="`header-${index}`"
            >
              {{ $t(item.i18n) || item.header }}
            </span>
            <!-- /Group Header -->

            <template v-else-if="!item.header">
              <!-- Nav-Item -->
              <v-nav-menu-item
                v-if="!item.submenu"
                :key="`item-${index}`"
                :index="index"
                :to="item.slug !== 'external' ? item.url : null"
                :href="item.slug === 'external' ? item.url : null"
                :icon="item.icon"
                :target="item.target"
                :awesomeIcon="item.awesomeIcon"
                :localIcon="item.localIcon"
                :localUrl="item.localUrl"
                :slug="item.slug"
                style="position: relative;"
              >
                <span v-show="!verticalNavMenuItemsMin" class="truncate" :style="{ color: item.isDisabled ? `${AISEA_COLOR.GRAY} !important` : null , }" >{{
                  $t(item.i18n) || item.name
                }}</span>
                <vs-chip
                  class="ml-auto"
                  :color="item.tagColor"
                  v-if="item.tag && (isMouseEnter || !reduce)"
                  >{{ item.tag }}</vs-chip
                >
                <div v-if="item.isDisabled" 
                  class="restriction-item"
                  @click.prevent="popupRestrictionInfo(item.isDisabled, ( $t(item.i18n) || item.name ) )" 
                />  
              </v-nav-menu-item>

              <!-- Nav-Group -->
              <template v-else>
                <v-nav-menu-group
                  :key="`group-${index}`"
                  :openHover="openGroupHover"
                  :group="item"
                  :groupIndex="index"
                  :open="isGroupActive(item)"
                />
              </template>
              <!-- /Nav-Group -->
            </template>
          </template>
          <span
            v-if="!verticalNavMenuItemsMin"
            class="navigation-header navigation-separation truncate aisea-text-12-700-white"
            key="navigation-separation"
          >
          </span>
           <!-- /Menu Items -->
          <div class="sidebar-company-name-wrapper">
            <div
              @mouseenter.stop.prevent="mouseEnter({ tag: 'companyName', evt: $event })"
              @mouseleave.stop.prevent="mouseLeave({ tag: 'companyName', evt: $event })"
              @mousedown.stop=""
              @touchstart.stop=""
              class="footer-sidebar sidebar-company-name vs-con-loading__container"
            >
              <vs-row vs-w="12">
                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="2"
                  vs-sm="2"
                  vs-xs="2"
                >
                  <img :src="iconOffice" />
                </vs-col>
                <vs-col
                  v-show="!verticalNavMenuItemsMin"
                  vs-type="flex"
                  vs-align="center"
                  vs-lg="10"
                  vs-sm="10"
                  vs-xs="10"
                >
                  <p v-if="user" class="cursor-pointer ml-2 aisea-text-14-400-white truncate">
                    {{ user.name }}
                  </p>
                </vs-col>
              </vs-row>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe="onSwipeAreaSwipe"
    />
    <!-- /Swipe Gesture -->

    <!-- 会社設定メニュー -->
    <div
      v-if="showCompanyMenuPanel"
      @mouseenter.stop="mouseEnter({ tag: 'companyMenuPanel', evt: $event })"
      @mouseleave.stop="mouseLeave({ tag: 'companyMenuPanel', evt: $event })"
      @mousedown.stop=""
      @touchstart.stop=""
      id="sidebar-company-logout-panel"
      class="vs-dropdown--custom vs-dropdown--menu"
    >
      <ul style="min-width: 9rem; white-space: nowrap;">
        <li class="flex py-2 px-4">
          <span class="feather-icon select-none relative"></span
          ><span class="ml-2">法人ID: {{ user.login_key || user.id }}</span>
        </li>

        <li class="flex py-2 px-4" v-if="user.account_id">
          <span class="feather-icon select-none relative"></span
          ><span class="ml-2">ユーザーID: {{ user.account_id }}</span>
        </li>

        <div class="vs-component vs-divider m-1">
          <span
            class="vs-divider-border after vs-divider-border-default"
            style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1);"
          ></span
          ><span
            class="vs-divider-border before vs-divider-border-default"
            style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1);"
          ></span>
        </div>

        <li 
          class="contact-area">
          <a 
            class="flex py-2 px-4 cursor-pointer"
            :href="urlContact" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            サービスに関するお問い合わせ
          </a>
        </li>

        <div class="vs-component vs-divider m-1">
          <span
            class="vs-divider-border after vs-divider-border-default"
            style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1);"
          ></span
          ><span
            class="vs-divider-border before vs-divider-border-default"
            style="width: 100%; border-top: 1px solid rgba(0, 0, 0, 0.1);"
          ></span>
        </div>
        <li
          @click.stop.prevent="onLogout"
          class="flex py-2 px-4 cursor-pointer logout-text hover:text-white"
        >
          <feather-icon icon="LogOutIcon" svgClasses="w-5 h-5"></feather-icon>
          <span class="ml-2">{{ $t("SideMenu.Logout") }}</span>
        </li>
      </ul>
    </div>


    <!-- メニューアイテム機能制限時のお問い合わせ促進ダイアログ -->
    <vs-prompt
      :title="`「${selectedMenuItemName}」機能はAisea PROを契約すると利用できます。`"
      type="confirm"
      :active.sync="showRestrictionInfo"
      :color="AISEA_COLOR.BLACK"
      buttons-hidden
      class="dialog-restriction-info"
    >
      <div class="dialog-restriction-info-body">
        詳しくは、以下お問い合わせフォームから営業担当までお問い合わせください。
      </div>
      <div class="flex w-full justify-end items-center mt-4">
        <vs-button :color="AISEA_COLOR.WHITE" class="mr-3 dialog-restriction-info-cancel" @click="cancelRestrictionInfo" >キャンセル</vs-button>
        <vs-button :color="AISEA_COLOR.BLUE"  class="ml-3" @click="linkToContactPage" >お問い合わせフォーム</vs-button>
      </div>
    </vs-prompt>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VNavMenuGroup from "./VerticalNavMenuGroup.vue";
import VNavMenuItem from "./VerticalNavMenuItem.vue";
import AuthService from "@/services/authService";
import FireStoreService from "@/services/fireStoreService";
import { debounce } from "lodash";
import Logo from "../Logo.vue";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import LocalDbService from "@/services/localDbService";

// Store
const {
  mapActions: mapActionsOfNotification,
  mapState: mapStateOfNotification
} = createNamespacedHelpers("notification");

const { mapActions: mapActionsOfAuth } = createNamespacedHelpers("auth");

const {
    mapState: mapStateOfBgTask
    } = createNamespacedHelpers("enterpriseBackgroundTaskManager");

export default {
  name: "v-nav-menu",
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo,
  },
  props: {
    logo: { type: String },
    openGroupHover: { type: Boolean, default: false },
    parent: { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems: { type: Array, required: true },
    version: { type: String }
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data: () => ({
    menus: null,
    clickNotClose: false, // disable close navMenu on outside click
    isMouseEnter: false,
    isMouseOnCompanyMenuPanel: false,
    reduce: false, // determines if navMenu is reduce - component property
    showCloseButton: false, // show close button in smaller devices
    settings: {
      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed: 1,
      swipeEasing: true
    },
    showShadowBottom: false,
    show: false,
    user: null,
    iconOffice: require("@/assets/images/icons/lolcal/office.svg"),
    intervalId: null,
    showCompanyMenuPanel: false,
    onHoverCompanyName: false,
    unsubscribeToggleReduce: () => {},
    showRestrictionInfo: false,
    selectedMenuItemName: "",
    urlContact: "https://aisea.net/contact/",
  }),
  computed: {
    ...mapStateOfNotification({
      unreadCount: state => state.unreadCount
    }),
    ...mapStateOfBgTask(["totalProgressTaskCount"]),
    isGroupActive() {

      return item => {
        const path = this.$route.fullPath;
        const routeParent = this.$route.meta
          ? this.$route.meta.parent
          : undefined;
        let open = false;

        let func = item => {
          if (item.submenu) {
            item.submenu.forEach(item => {
              if (
                item.url &&
                (path === item.url || routeParent === item.slug)
              ) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(item);
        return open;
      };
    },
    isVerticalNavMenuActive: {
      get() {
        return this.$store.state.isVerticalNavMenuActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", val);
      }
    },
    layoutType() {
      return this.$store.state.mainLayoutType;
    },
    reduceButton: {
      get() {
        return this.$store.state.reduceButton;
      },
      set(val) {
        this.$store.commit("TOGGLE_REDUCE_BUTTON", val);
      }
    },
    isVerticalNavMenuReduced() {
      return Boolean(this.reduce && this.reduceButton);
    },
    verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isMobileDevice() {
      // NOTE: 現状、ユーザエージェントでモバイル判定
      return ["iPhone", "iPad"].includes(this.getDeviceInfo().deviceType);
    },
    isSecureDataflow() {
      return this.$route.meta.isSecureDataflow;
    },
    isPortMasterFullScreen() {
      return this.$route.meta.isPortMasterFullScreen;
    },
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
    },
    reduce(val) {
      const verticalNavMenuWidth = val
        ? "reduced"
        : this.$store.state.windowWidth < 600
        ? "no-nav-menu"
        : "default";
      this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);

      // setTimeout(function() {
      //   window.dispatchEvent(new Event("resize"));
      // }, 100);
    },
    layoutType() {
      this.setVerticalNavMenuWidth();
    },
    reduceButton() {
      this.setVerticalNavMenuWidth();
    },
    windowWidth() {
      this.setVerticalNavMenuWidth();
    },
    unreadCount(unreadCount) {
      this.menus.forEach(v => {
        if (v.id === 7) {
          // お知らせ
          if (unreadCount === 0) {
            v.tag = "";
          } else {
            v.tag = unreadCount;
          }
        }
      });
    },
    totalProgressTaskCount(count){
      this.menus.forEach(item => {
        if(item.slug !== "task-manager") return;
        if(count === 0) {
          item.tag = "";
        } else {
          item.tag = count;
        }
      });
    },
  },
  methods: {
    ...mapActionsOfNotification(["fetchUnreadNotifications"]),
    ...mapActionsOfAuth(["logout"]),
    onMenuSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
      // Swipe Left
      else if (event.direction === 2 && !this.$vs.rtl) {
        if (this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = false;
      }
    },
    onSwipeAreaSwipe(event) {
      // Swipe Right
      if (event.direction === 4 && !this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
      // Swipe Left
      else if (event.direction === 2 && this.$vs.rtl) {
        if (!this.isVerticalNavMenuActive && this.showCloseButton)
          this.isVerticalNavMenuActive = true;
      }
    },
    psSectionScroll() {
      const scroll_el =
        this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs;
      this.showShadowBottom = scroll_el.scrollTop > 0 ? true : false;
    },
    mouseEnter(event) {
      if (event.tag === "companyName") {
        this.showCompanyMenuPanel = true;
      }

      if (event.tag === "companyMenuPanel") {
        this.isMouseOnCompanyMenuPanel = true;
      }

      if (this.reduce) {
        if (event.tag !== "companyMenuPanel") {
          this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
          this.isMouseEnter = true;
        }
      }
    },
    mouseLeave(event) {
      if (event.tag === "companyMenuPanel") {
        this.isMouseOnCompanyMenuPanel = false;
        this.showCompanyMenuPanel = false;
      }

      if (this.reduce && !(event.tag === "companyName")) {
        this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", true);
        this.isMouseEnter = false;
      }

      if (event.tag === "companyName") {
        let self = this;
        let hideCompanyMenuPanel = debounce(function() {
          if (!self.isMouseOnCompanyMenuPanel) self.showCompanyMenuPanel = false;
        }, 100);
        hideCompanyMenuPanel();
      }
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 400 && !this.isMobileDevice) {
        if (this.layoutType === "vertical") {
          // Set reduce
          this.reduce = this.reduceButton ? true : false;

          // Open NavMenu
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin =
            this.reduceButton && !this.isMouseEnter ? true : false;
          this.$store.commit(
            "UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN",
            verticalNavMenuItemsMin
          );

          // Menu Action buttons
          this.clickNotClose = true;
          this.showCloseButton = false;

          const verticalNavMenuWidth = this.isVerticalNavMenuReduced
            ? "reduced"
            : "default";
          this.$store.dispatch(
            "updateVerticalNavMenuWidth",
            verticalNavMenuWidth
          );

          return;
        }
      }

      // Close NavMenu
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);

      // Reduce button
      if (this.reduceButton) this.reduce = false;

      // Menu Action buttons
      this.showCloseButton = true;
      this.clickNotClose = false;

      // Update NavMenu Width
      this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");

      // Remove Only Icon in Menu
      this.$store.commit("UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN", false);
    },
    toggleReduce(val) {
      this.reduceButton = val;
      this.setVerticalNavMenuWidth();
    },
    toggleSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", !this.isVerticalNavMenuActive);
    },
    async setMenuItems() {
      let clone = this.navMenuItems.slice();

      for (let [index, item] of this.navMenuItems.entries()) {
        if (item.header && item.items.length && (index || 1)) {
          let i = clone.findIndex(ix => ix.header === item.header);
          for (let [subIndex, subItem] of item.items.entries()) {
            clone.splice(i + 1 + subIndex, 0, subItem);
          }
        }
      }

      this.menus = await this.$store.getters.getMenuItems(clone);

      const enterpriseAccountSettings = await FireStoreService.getEnterpriseAccountSettings();
      if ( enterpriseAccountSettings['port_master_read_only'] === true ) {
        // PortMaster読み取り専用の設定がされているアカウントは、メニュー表示をPortMaster関連だけに限定する。
        this.menus = this.menus.filter(menuItem => menuItem.slug === 'PortMaster')
      }

    },
    setNotificationObserver() {
      // お知らせの有無を5分毎にチェック
      this.intervalId = this.$setInterval(() => {
        this.updateNotificationsBadge();
      }, 300000);
    },
    async updateNotificationsBadge() {
      await this.fetchUnreadNotifications();
    },
    async setCompanyInfo() {
      this.user = await AuthService.getUser();
    },
    popupRestrictionInfo (isDisabled, name) {
      if ( isDisabled ) {
        this.selectedMenuItemName = name;
        this.showRestrictionInfo = true;
      }
    },
    linkToContactPage() {
      window.open('https://aisea.net/contact/', 'aisea_contact');
      this.showRestrictionInfo = false;
    },
    cancelRestrictionInfo() {
      this.$nextTick(() => {
        this.showRestrictionInfo = false;
      });
    },
    async onLogout() {
      this.$vs.loading();
      this.$clearAllIntervals();
      await this.logout();
      this.$vs.loading.close();
      this.$vs.notify({
        title: "ログアウトしました",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      });
    },
    onContact(){
      console.log("onContact");
    },
    /**
     *  iPhone,iPadでのレフトメニュー表示制御.
     */
    onResize() {
      this.$nextTick(() => {
        if (this.isMobileDevice || this.isSecureDataflow || this.isPortMasterFullScreen ) {
          this.showCloseButton = !this.isSecureDataflow;
          // iPhone, iPad はメニューを表示しない。
          // SecureDataFlowはメニューを表示しない。
          // PortMasterで全画面モードのページはメニューを表示しない。
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
          this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
        } else {
          this.showCloseButton = false;
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
          const verticalNavMenuWidth = this.isVerticalNavMenuReduced
            ? "reduced"
            : "default";
          this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);
        }
      });
    },
    setSubscribeToggleReduce() {
      const unsubscribeToggleReduce = this.$store.subscribe((mutation, state) => {
        // メニュー縮小状態が変化時、縮小状態をindexedDBに保管する
        if (mutation.type === "TOGGLE_REDUCE_BUTTON") {
          LocalDbService.saveLeftMenuReduceState({
            reduceState: state.reduceButton
          });
        }
      });
      return unsubscribeToggleReduce;
    },
  },
  async created(){
    await this.setCompanyInfo();
  },
  async mounted() {
    this.setVerticalNavMenuWidth();
    await this.setMenuItems();
    await this.updateNotificationsBadge();
    this.setNotificationObserver();
    this.show = true;
    this.showCloseButton = this.isMobileDevice && !this.isSecureDataflow;
    this.onResize();
    if(!this.isMobileDevice) {
      // 保存されていた左メニュー縮小状態をstateに反映
      this.$store.dispatch("setReduceState").then(() => {
        // 縮小状態をstateに反映後に購読開始
        this.unsubscribeToggleReduce = this.setSubscribeToggleReduce();
      });
    }
  },

  beforeDestroy() {
    if (this.intervalId) {
      this.$clearInterval(this.intervalId);
    }
  },
  destroyed() {
    this.unsubscribeToggleReduce();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss";
@import "@/assets/scss/aisea/_variables.scss";

.scroll-area--aisea-menu {
  height: calc(var(--vh, 1vh) * 100) !important;
  &:not(.ps) {
    overflow-y: auto;
  }
  display: flex;
  flex-direction: column;
  padding-top: 0px;

  .slider-items-wrapper {
    flex: 1 0 auto;
  }
}
.aisea-logo-text {
  font-family: "futura-pt";
  font-size: 28px;
  font-weight: 500;
  color: #f0f0f0 !important;
  letter-spacing: 0.3em;
}

.aisea-version-text {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  text-align: right;
  color: white;
  margin-top: -8px;
  width: 130px;
}

.sidebar-company-name-wrapper {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  margin-top: auto;
  flex-shrink: 0;
  flex-grow: 0;
  flex-basis: 54px;
}

.sidebar-company-name {
  white-space: normal;
  background-color: $aisea-blue-gray;
  border: 2px solid $aisea-blue-gray;
  padding: 5px 15px;
  font-size: 15px;
  color: #ffffff;
  img {
    vertical-align: middle;
    position: relative;
    top: -0.2em;
    background-color: $aisea-blue-gray;
  }
}

#sidebar-company-logout-panel {
  z-index: 51001;
  position: fixed;
  bottom: 10px;
  left: 270px;
  @media screen and (max-width: $max-width-iphone-8) {
    left: 10px;
    bottom: 50px;
  }

  .contact-area {
    a {
      color: $aisea-dark-gray;
    }
    a:hover {
      color: $aisea-white;
    }
  }
  .contact-area:hover {
    background-color: #48A0F4;
    
  }


  .logout-text:hover {
    background-color: #48A0F4;
  }
}

.theme-semi-dark {
  .v-nav-menu {
    .vs-sidebar {
      background-color: $aisea-dark-blue;
    }
    .vs-sidebar--item {
      a {
        border-radius: 5px;
      }
      .router-link-active {
        background: #48A0F4;
        box-shadow: none;
      }
      &.disabled-item {
        a {
          span {
            opacity: 0.4;
          }
        }
      }
    }
    .restriction-item {
      position: absolute;
      top:        0;
      left:       0;
      width:   100%;
      height:  100%;
      z-index:  999;
    }
    .navigation-header,
    .navigation-separation {
      width: 221px;
      border-top: solid 1px $aisea-gray;
      margin-top: 1rem;
      margin-left: 17px;
      margin-right: 22px;
      padding-top: 16px;
      padding-left: 10px;
      overflow: visible;
    }
    .navigation-separation {
      margin-bottom: auto;
    }
    .text-capitalize {
      text-transform: capitalize;
    }
    .con-vs-chip {
      background: rgba(#1256B1, 1);
      box-shadow: none !important;
    }
  }
  .header-sidebar {
    height: 87px;
    max-height: 87px;
    background-color: $aisea-dark-blue;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    left: 0;
    z-index: 4;
    padding: 20px 7.5px 16px 23px !important;
    .close-reduce-btn-wrapper {
      width: 36px;
      height: 36px;
      padding: 11.5px;
      .reduce-active {
        transform: rotate(180deg);
      }
    }
  }
}
.dialog-restriction-info {
  .vs-dialog {
    max-width: 560px !important;
    min-height: 10rem !important;

    .vs-dialog-header {
      background-color: $aisea-pure-white;
      h3 {
        margin-top: 1rem;
        font-weight: 500;
        font-size: 16px;
      }
    }
    .dialog-restriction-info-body {
      margin-left: 0.2rem;
      font-size: 16px;
      font-weight: 500;
    }
    .dialog-restriction-info-cancel {
      color: $aisea-black;
    }
  }
}
</style>
